module.exports = __webpack_public_path__ + "static/media/close.8bf185b4.svg";